import { IBrandCartV2WithSummary } from "@faire/deprecated-retailer-visitor-shared/stores/domain/CartStore/consts";
import { QueryParameters as CheckoutParamaters } from "@faire/web-api--source/endpoints/www/api/v2/carts/cartToken/checkout-summary/get";
import { ShippingEstimatePolicy } from "@faire/web-api--source/indigofair/data/ShippingEstimatePolicy";

/**
 * Helper function to get the initial checkout cart summary request. Needed so that
 * the prefetch request and the initial request are the same.
 */
export const getInitialCheckoutCartSummaryRequest = (
  brandTokens?: string[],
  shippingEstimatePolicy?: ShippingEstimatePolicy
): CheckoutParamaters =>
  CheckoutParamaters.build({
    brand_tokens: brandTokens,
    shipping_estimate_policy: shippingEstimatePolicy,
  });

export const getHasBrandThatSupportsGuaranteedShipping = (
  brandCarts: IBrandCartV2WithSummary[]
): boolean => brandCarts.some((brand) => brand.supports_guaranteed_shipping);

export const getShouldPreloadCheckoutSummaryWithEasyPostEstimates = (
  brandCarts: IBrandCartV2WithSummary[]
): boolean => {
  return (
    !getHasBrandThatSupportsGuaranteedShipping(brandCarts) &&
    brandCarts.length === 1
  );
};

/**
 * Helper function to determine if we should send the second checkout summary request.
 * The second request is more accurate and longer to compute.
 */
export const shouldSendSecondCheckoutSummaryRequest = (
  brandCarts: IBrandCartV2WithSummary[]
): boolean => {
  return (
    getHasBrandThatSupportsGuaranteedShipping(brandCarts) ||
    getShouldPreloadCheckoutSummaryWithEasyPostEstimates(brandCarts)
  );
};

/**
 * Returns the shipping estimate policy to use for the first checkout summary request.
 */
export const getFirstShippingEstimatePolicy = (
  brandCarts: IBrandCartV2WithSummary[]
) => {
  if (getHasBrandThatSupportsGuaranteedShipping(brandCarts)) {
    return ShippingEstimatePolicy.GUARANTEED_PRELOAD;
  } else if (getShouldPreloadCheckoutSummaryWithEasyPostEstimates(brandCarts)) {
    return ShippingEstimatePolicy.EASYPOST_PRELOAD;
  }
  return undefined;
};

/**
 * Returns the shipping estimate policy to use for the second checkout summary request.
 */
export const getSecondShippingEstimatePolicy = (
  brandCarts: IBrandCartV2WithSummary[]
) => {
  if (getHasBrandThatSupportsGuaranteedShipping(brandCarts)) {
    return ShippingEstimatePolicy.GUARANTEED_FULL;
  } else if (getShouldPreloadCheckoutSummaryWithEasyPostEstimates(brandCarts)) {
    return ShippingEstimatePolicy.EASYPOST_ESTIMATES_ONLY;
  }
  return undefined;
};
